import { useState, createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  getNotificationsWaiterService,
  deleteNotificationWaiterService,
  deleteAllNotificationWaiterService,
} from "../../../services/waiterServices";

export const notificationWaiterContext = createContext({
  notifications: [],
  setNotifications: () => {},
  notification: {},
  setNotification: () => {},
  handleGetNotifications: () => {},
  handleDeleteNotification: () => {},
  handleDeleteAllNotification: () => {},
});

const NotificationWaiterContext = ({ children }) => {
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);
  const [notification, setNotification] = useState({});

  // Get Notifications
  const handleGetNotifications = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getNotificationsWaiterService();
      if (status === 200) {
        setNotifications(data.result?.notifications);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Notification
  const handleDeleteNotification = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteNotificationWaiterService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetNotifications();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete All Notification
  const handleDeleteAllNotification = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteAllNotificationWaiterService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetNotifications();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <notificationWaiterContext.Provider
      value={{
        notifications,
        setNotifications,
        notification,
        setNotification,
        handleGetNotifications,
        handleDeleteNotification,
        handleDeleteAllNotification,
      }}
    >
      {children}
    </notificationWaiterContext.Provider>
  );
};

export default NotificationWaiterContext;
